import HTTP from '../HTTP';

export async function sendMail(mail, url) {
  try {
    const response = await HTTP.post(url, mail);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function other(mail) {
  try {
    const response = await HTTP.get(mail);
    return response;
  } catch (e) {
    throw e;
  }
}




// WEBPACK FOOTER //
// ./src/api/mail/index.js